import { Link } from "react-router-dom";
import ReactNavbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import { surmountLogoLight } from "assets/icons/index";
import { Breadcrumbs } from "components/Breadcrumbs";
import { HOME_PATH } from "features/Dashboard/routes";
import { AuthButtons } from "../Components";

export const NavbarPublic = () => {
  return (
    <>
      <ReactNavbar.Toggle aria-controls="responsive-navbar-nav" />

      <Link to={HOME_PATH} className="link-logo">
        <img alt="logo" src={surmountLogoLight} className="main-logo" />
      </Link>

      <ReactNavbar.Collapse
        id="responsive-navbar-nav"
        className="justify-content-end"
      >
        <Breadcrumbs />
        <Nav>
          <AuthButtons className="desktop-view" />
        </Nav>
      </ReactNavbar.Collapse>
    </>
  );
};
